import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IOfferGallery} from "../detail/types/IOfferGallery";

interface IGetOfferGalleryResponse {
    gallery: IOfferGallery;
}

export const getOfferGallery = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getOfferGallery: build.query<IOfferGallery, number>({
            query: (offerId) => ({
                url: apiV2Link.offer.pictures(Scenario.OFFER_DETAIL_GALLERY, {offerId})
            }),
            transformResponse: (response: IGetOfferGalleryResponse) => response.gallery
        })
    })
});

export const {useGetOfferGalleryQuery} = getOfferGallery;
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IOfferGallery} from "../detail/types/IOfferGallery";

interface IGetOfferGalleryResponse {
    gallery: IOfferGallery;
}

export const getOfferGallery = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getOfferGallery: build.query<IOfferGallery, number>({
            query: (offerId) => ({
                url: apiV2Link.offer.pictures(Scenario.OFFER_DETAIL_GALLERY, {offerId})
            }),
            transformResponse: (response: IGetOfferGalleryResponse) => response.gallery
        })
    })
});

export const {useGetOfferGalleryQuery} = getOfferGallery;
